function SwatchesConstructor_custom(t,e){
    var n=this;
    n.show_unavailable_options=e.show_unavailable_options||!1,n.productIsValid=n.show_unavailable_options||t.available,n.product_json=t,n.options_name="",n.options="",n.viewDesign=window.viewButtons,n.designOption1=e.designOption1||"getButtonHtml",n.designOption2=e.designOption2||"getButtonHtml",n.designOption3=e.designOption3||"getButtonHtml",n.contentParent=e.contentParent,n.enableHistoryState=Boolean(e.enableHistoryState)||!1,n.callback=e.callback||!1,n.texture_obj=e.externalImagesObject||{},n.colors_obj=e.externalColors||{},n.color_with_border=e.colorWithBorder||{},n.product_handle=e.productHandle||{},n.selectedByDefault=void 0===e.selectedByDefault||e.selectedByDefault,n.productIsValid&&"Title"!=t.options&&$(n.contentParent).length?n.initSwatches():n.callExternalVariantHandler(n.callback,t.variants[0],n.getJsonObject())
}
function getAllOptions(t,e){
    for(var n=!0,a={},i=0;i<t.length;i++){
        n=!!e||Boolean(t[i].available);
        var o=t[i].option1,l=t[i].option2,r=t[i].option3;
        null!=o&&n&&(null!=l?(a[o]=a[o]||{},null!=r?(a[o][l]=a[o][l]||{},a[o][l][r]=!e||Boolean(t[i].available)):a[o][l]=!e||Boolean(t[i].available)):a[o]=!e||Boolean(t[i].available))}var c=!1;return $.each(a,function(t,e){
            if(o=t,"object"==typeof a[t]&&"Default Title"!=t){
                var n=a[t];$.each(n,function(t,e){l=t,c=!1,"object"==typeof n[t]&&($.each(n[t],function(t,e){c||(c=c||e)}),a[o][l+"_|av"]=c)}),c=!1,$.each(n,function(t,e){var a=e;(hasOwnProperty.call(n,t+"_|av")||t.indexOf("_|av")>-1)&&(a=t.indexOf("_|av")>-1&&n[t]),c||(c=c||a)}),a[o+"_|av"]=c
            }
        }),a
}
function getCurrentOptionsArray(t){
    var e=t.option1+"%%"+t.option2+"%%"+t.option3;
    return e.replace(/\%\%null/g,"").split("%%")
}
function getCurrentVariantById(t,e,n){
    for(var a=0;a<t.length;a++){
        var i=!!n||t[a].available;if(e){if(t[a].id==e)return t[a]}else if(i)return t[a]
    }
        return t[0]
}
function getCurrentVariantByTitle(t,e,n){
    if(!e)return t[0];for(var a=!0,i=0;i<t.length;i++){
        var o="%%"+t[i].title,l=!!n||t[i].available;if(o.indexOf("%%"+e)>-1&&l&&!a)return t[i];if(t[i].title===e&&l&&a)
        return t[i];i==t.length-1&&e.indexOf("/")>-1&&((e=e.split("/")).pop(),e=e.length>1?e.join("/"):e,i=0,a=!1)
    }
    return t[0]
}
function getVariantIdUrl(){
    var t=location.search;return t.indexOf("variant=")>-1&&(t=t.match(/variant=\d+/g),t=parseInt(t[0].match(/\d+/g))),t
}
function isEmpty(t){
    return 0===Object.keys(t).length
}
function viewButtons(t,e){
    var n=".tt-wrapper",a=(e=e||{}).selectedByDefault,i=void 0===e.avaibility||e.avaibility;switch(t){
        case"getFunctionClickHandler":
            return"buttonHandler";
        case"getGroupElementName":
            return n;
        case"getGroupHtml":;
        if(e.title=='Color'){
          e.title='Bitte wählen Sie ein Farbe';
        	var text = '<div class="'+n.replace(/([\.#])/g,"")+'"><div class="tt-title-options">'+e.title+': <span class="current_option_name"></span></div><ul class="tt-options-swatch options-large option-color">'+e.html+"</ul></div>";
        }
        else if ( e.title=='Size') {
          e.title='Bitte wählen Sie eine verfügbare Größe';
          var text = '<div class="'+n.replace(/([\.#])/g,"")+'"><div class="tt-title-options">'+e.title+': <span class="current_option_name"></span></div><ul class="tt-options-swatch options-large option-size">'+e.html+"</ul></div>";
        }else{
        	return'<div class="'+n.replace(/([\.#])/g,"")+'"><div class="tt-title-options">'+e.title+': <span class="current_option_name"></span></div><ul class="tt-options-swatch options-large option-size">'+e.html+"</ul></div>";
        }
            return text;
        case"getButtonHtml":
            var o=e.value.trim(),l=o.toLowerCase(),r=e.c_border.indexOf(o)>-1?" border":"",c=e.producthandle;l=","+l+":",l=e.colors.indexOf(l)>-1&&e.colors.split(l).pop().split(",").shift().trim();var s=o in e.texture?' data-optionimage="true" style="background-image:url('+e.texture[o]+')"':"";c+" "+o in e.texture&&(s=' data-optionimage="true" style="background-image:url('+e.texture[c+" "+o]+')"'),""==s&&l&&(s=' style="background:'+l+'; border-color:'+l+' !important"');var u=s.indexOf("data-optionimage")>-1?' class="options-color-image"':"",d=i?"":"<span"+u+"></span>",p=o.indexOf('"')>-1?"'"+o+"'":'"'+o+'"';i=i?"":' data-availability="false"';var f=""!=s?"<li"+i+">"+d+'<a href="#" class="options-color'+r+'" data-value="'+o+'" data-tooltip="'+o+'" '+s+"></a></li>":"<li"+i+'><a href="#" data-value='+p+">"+o+"</a></li>";
            return e.value==e.selected&&a?f.replace(/<li/,'<li class="active"'):f;
        case"getSelectGroupHtml":
            return'<div class="'+n.replace(/([\.#])/g,"")+'"><div class="tt-title-options">'+e.title+': <span class="current_option_name"></span></div><div class="form-default"><div class="form-group"><select class="form-control">'+e.html+"</select></div></div></div>";
        case"getSelectButtonHtml":
            return f="<option>"+e.value.trim()+"</option>",e.value==e.selected&&a?f.replace(/<option/,"<option selected"):f;
        case"showSelectedParametres":
            return 0!=$(n).find(".active").length&&($(n).find(".active").each(function(){
                var t=$(this).find("[data-value]").data("value");$(this).closest(n).find(".current_option_name").text()}),!1)}
            }SwatchesConstructor_custom.prototype.destroy=function(){
                var t=$(this.contentParent);t.find("a").unbind(),t.find("select").unbind(),t.empty()},SwatchesConstructor_custom.prototype.initSwatches=function(t){
                    var e,n=this,a=[];t=t,e=n.getJsonObject().options;for(var i=0;i<e.length;i++)a[i]=Object(e[i]).name;n.options_name=a,n.options=getAllOptions(n.getJsonObject().variants,n.show_unavailable_options),t||(t=n.enableHistoryState&&getVariantIdUrl()),n.createSwatches(t)
                },SwatchesConstructor_custom.prototype.createSwatches=function(t){var e=this,n=e.viewDesign;
                    if(isEmpty(e.options))return!1;
                    var a=getCurrentVariantById(e.getJsonObject().variants,t,e.show_unavailable_options),i=getCurrentOptionsArray(a);e.createOptionsView(e.contentParent,e.options,e.options_name,i),e[n("getFunctionClickHandler")](),e.callExternalVariantHandler(e.callback,a,e.getJsonObject()),e.selectedByDefault=!0
                },SwatchesConstructor_custom.prototype.buttonHandler=function(){
                    var t=this,e=t.viewDesign,n=$(t.contentParent),a=e("getGroupElementName"),i=n.find(a);function o(e){if("a"===e[0].localName){if(e.hasClass("active"))return!1;0==n.find(".active").length&&i.each(function(){$(this).find("ul").find("li").first().addClass("active")}),i.find("a").unbind(),e.closest(a).find(".active").removeClass("active"),e.parent().addClass("active")}else e.unbind("focusin");var o="";i.each(function(){$(this).find(".active").length?o+=$(this).find(".active").find("[data-value]").data("value")+" / ":o+=$(this).find("select option:selected").text()+" / "}),t.endOfTheClickHandler(o)}i.find("a").on('touchstart click',function(t){t.preventDefault(),o($(this))}),i.find("select").change(function(){o($(this))}),t.selectedByDefault||i.find("select").focusin(function(t){o($(this))})
                },SwatchesConstructor_custom.prototype.endOfTheClickHandler=function(t){
                    var e=this;t=t.substring(0,t.length-3);var n=getCurrentVariantByTitle(e.getJsonObject().variants,t,e.show_unavailable_options);e.enableHistoryState&&history.pushState(null,null,location.pathname+"?variant="+n.id),e.createSwatches(n.id),$(e.contentParent).closest(".tt-product-single-info").find(".input_variant").val(n.id)
                },SwatchesConstructor_custom.prototype.createOptionsView=function(t,e,n,a){
                    var i=this,o=i.viewDesign,l=$(t).empty(),r=i.texture_obj,c=i.colors_obj,s=i.color_with_border,u="",d="",p="",f=[i.designOption1,i.designOption2,i.designOption3],v=i.product_handle,h=i.selectedByDefault,g=!1;$.each(e,function(t,i){if(t==a[0]&&"object"==typeof e[t]&&"Default Title"!=t&&-1==t.indexOf("_|av")){var l=e[t];$.each(l,function(t,e){t==a[1]&&"object"==typeof l[t]&&-1==t.indexOf("_|av")&&$.each(l[t],function(t,e){p+=o(f[2],{avaibility:e,value:t,selected:a[2],title:n[2],texture:r,colors:c,c_border:s,producthandle:v,selectedByDefault:h})}),-1==t.indexOf("_|av")&&(g="object"==typeof l[t]?l[t+"_|av"]:e,d+=o(f[1],{avaibility:g,value:t,selected:a[1],title:n[1],texture:r,colors:c,c_border:s,producthandle:v,selectedByDefault:h}))})}"Default Title"!=t&&-1==t.indexOf("_|av")&&(g="object"==typeof e[t]?e[t+"_|av"]:i,u+=o(f[0],{avaibility:g,value:t,selected:a[0],title:n[0],texture:r,colors:c,c_border:s,producthandle:v,selectedByDefault:h}))});for(var b=[n[0],n[1],n[2]],y=[u,d,p],_=0;_<y.length;_++)""!=y[_]&&l.append(o(f[_].indexOf("getSelect")>-1?"getSelectGroupHtml":"getGroupHtml",{title:b[_],html:y[_]}));o("showSelectedParametres")
                },SwatchesConstructor_custom.prototype.getJsonObject=function(){
                    return this.product_json
                },SwatchesConstructor_custom.prototype.callExternalVariantHandler=function(t,e,n){t&&"function"==typeof t&&t(e,n)};





/* swatches_and_quickview */
var textforbutton = '';
var global_quantity;
var global_quantity_qw = false;
var _custom_loader = $('.custom-loader');
var modal_qv_parent = $('#ModalquickView');
var modal_qv_open = false;
var modal_qv_content = modal_qv_parent.find('.modal-content');
if(modal_qv_parent.length) {
  modal_qv_parent.on('show.bs.modal', function(e) {
    /* modal */
    modal_qv_open = true;
    _custom_loader.show();
    modal_qv_content.hide();//hide content
    var relatedTarget = $(e.relatedTarget).filter(':first');

    global_quantity_qw = global_quantity;
    global_quantity = {};
    var qa = relatedTarget.attr('data-quantity').split(';');
    if(qa.length > 0){
      for(var i = 0; i < qa.length; i++){
        if(qa[i] === '') break;
        var _qa = qa[i].split('-');
        global_quantity[_qa[0]] = _qa[1];
      }
    }

    var attr = relatedTarget.attr('data-value');
    var optionimages = relatedTarget.attr('data-optionimages');
    
    var small_description = relatedTarget.closest('.product-parent').find('.description').html();
    var fn = window['configureQuickView'];
    typeof(fn) === "function" && fn(attr, small_description, optionimages);
  }).on('hidden.bs.modal', function () {
    global_quantity = global_quantity_qw;
    modal_qv_open = false;
    var fn = window['destroyQuickView'];
    typeof(fn) === "function" && fn();
  });
}

var quick_view_loader = {
  btn: false,
  wait: function(_btn){
    if(!modal_qv_open) return false;
    this.btn = _btn;
    _btn.html(wait_text);
  },
  error: function(){
  	if(!modal_qv_open) return false;
    this.btn.addClass('quickview-error').html(errorhtml_text);
    this.default_text('quickview-error');
  },
  added: function(){
    if(!modal_qv_open) return false;
    this.btn.addClass('quickview-added').html(addedhtml_text);
    this.default_text('quickview-added');
  },
  default_text: function(value){
    setTimeout(function(){quick_view_loader.btn.removeClass(value).html(textforbutton)}, 1000);
  }
}

var quickview_swatches = false;
function configureQuickView(product_url, small_description, optionimages){
  var handle = product_url.split('/').pop();
  Shopify.getProduct(handle, qvLoadSuccess);

  /* hide preloader when ajax error */
  function qvLoadSuccess(json_data){
    var swatchesdesign1 = $('.tt-quickview-swatches-container-js').length && $('.tt-quickview-swatches-container-js').data('swatches-design1');
    var swatchesdesign2 = $('.tt-quickview-swatches-container-js').length && $('.tt-quickview-swatches-container-js').data('swatches-design2');
    var swatchesdesign3 = $('.tt-quickview-swatches-container-js').length && $('.tt-quickview-swatches-container-js').data('swatches-design3');
    var cur_opt = optionimages != null ? JSON.parse(optionimages) : '';
    var full_opt = cur_opt != '' ? $.extend( texture_obj, cur_opt ) : texture_obj;
    var product_handle = json_data.handle;
    var show_unavailable_options = $('.show_unavailable_variants').length > 0;

    quickview_swatches = new SwatchesConstructor(json_data, {contentParent: '.tt-quickview-swatches-container-js', enableHistoryState: false, callback: quickViewVariant, externalImagesObject: full_opt, externalColors: colors_value, colorWithBorder: color_with_border, productHandle:product_handle, designOption1:swatchesdesign1, designOption2:swatchesdesign2, designOption3:swatchesdesign3, show_unavailable_options: show_unavailable_options });
    json_data = null;
    /* modal */
    _custom_loader.hide();
    modal_qv_content.fadeIn();//show content
  }
  function quickViewVariant(variant, product){
    var _ = modal_qv_parent;
    var _parent_general_info = _.find('.tt-product-single-info');
    var _swatch = _.find('.tt-quickview-swatches-container-js');
    swatchVariantHandler(_parent_general_info, variant);
    swatchVariantButtonHandler(_parent_general_info, variant);
    addToCartHandler.initFormAddToCartButton(variant.id, _parent_general_info, _swatch);
    
    _.find('.input_variant').attr('value', variant.id);
    _.find('.tt-title').html(product.title);
    _.find('.viewfullinfo') && _.find('.viewfullinfo').attr('href', product_url);

    _.find('.qv_vendor') && _.find('.qv_vendor').html(product.vendor);
    var qv_type = _.find('.qv_type');
    if(qv_type.length){
      product.type == '' ? qv_type.parent().hide() : qv_type.html(product.type).parent().show();
    }
    
    var _img = _.find('.product-main-image');
    var img_src = variant.featured_image ? variant.featured_image.src : product.featured_image;
    if(_img.children().length) _img.children().first().attr('src', img_src)
    else $('<img src="'+img_src+'" alt="Quick View Image">').appendTo(_img);
    
    var description = _.find('.description').empty();
    description.length && description.html(small_description);

    if($(".spr-badge").length > 0 && _.find('.rating').children().length == 0) {
      _.find('.rating').append("<span class=\"shopify-product-reviews-badge\" data-id=\""+product.id+"\"></span>");
      $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
    }
  }
}
function destroyQuickView(){
  quickview_swatches && quickview_swatches.destroy();
  quickview_swatches = false;
  var _ = modal_qv_parent;
  _.find('.product-main-image').empty();
  _.find('.description').empty();
  _.find('.swatches-container').empty();  
  _.find('.title').empty();
  _.find('.rating').empty();  
}


function swatchVariantHandler(_parent, variant) {
  var _ = _parent;
  var _price = _.find('.tt-price');
  var _info = _.find('.tt-add-info');
  var _sku = _info.length && _info.find('.sku-js');
  var _avaibility = _info.length && _info.find('.availability');
  var _input = _.find('.tt-input-counter').find('input');
  
  var _barcode = _.find('.barcode');

  var price_str = Shopify.formatMoney(variant.price, money_format);
  var price_comare_str = Shopify.formatMoney(variant.compare_at_price, money_format);
  if(variant.price < variant.compare_at_price){
    _price.find('>span:first').addClass('sale-price').html(price_str);
    _price.find('>span:last').removeClass('hide').html(price_comare_str);
  }
  else {
    _price.find('>span:first').removeClass('sale-price').html(price_str);
    _price.find('>span:last').addClass('hide');
  }
  
  if(_sku.length) {
    _sku.each(function(){
      $(this).children().last().html(variant.sku);
    })
    variant.sku == '' ? _sku.addClass('hide') : _sku.removeClass('hide');
  }
  
  if(_barcode.length) {
    _barcode.html(variant.barcode);
    variant.barcode === null || variant.barcode == '' ? _barcode.parent().addClass('hide') : _barcode.parent().removeClass('hide');
  }
  
  // Inventory Quantity
  var inventory_management = variant.inventory_management;
  var inventory_quantity = String(global_quantity[variant.id]);

  if(Boolean(variant.available)){
    var iq = Number(inventory_quantity.split('continue').pop());
    if(inventory_management == null){
      iq = 9999;
      if(_avaibility.length){
        _avaibility.find('.sold_out, .stock_quantity, .in_stock, .continue_out').addClass('hide');
        _avaibility.find('.many_in_stock').removeClass('hide');
      }
    }
    
    if(inventory_management == 'shopify'){
      if(iq <= 0){
        iq = 9999;
        if(_avaibility.length){
          _avaibility.find('.sold_out, .many_in_stock, .stock_quantity, .in_stock').addClass('hide');
          _avaibility.find('.continue_out').removeClass('hide');
        }
      }
      else{
        if(_avaibility.length){
          _avaibility.find('.stock_quantity').removeClass('hide').html(iq);
          _avaibility.find('.in_stock').removeClass('hide');
          _avaibility.find('.sold_out, .many_in_stock, .continue_out').addClass('hide');
        }
      }
    }
      
    _input.val(1).attr('size', iq);
  }
  else{
    if(_avaibility.length){
      _avaibility.find('.continue_out, .stock_quantity, .in_stock, .many_in_stock').addClass('hide');
      _avaibility.find('.sold_out').removeClass('hide');
    }
  }  
  
  $('body').trigger('refreshCurrency');
}
function swatchVariantButtonHandler(_parent, variant) {
  console.log("rrr");
  var _btnaddtocart = _parent.find('.btn-addtocart');
  if(_btnaddtocart.length == 0) return false

  if(Boolean(variant.available)) {
    var inventory_management = variant.inventory_management;
    var inventory_quantity = String(global_quantity[variant.id]);
    var iq = Number(inventory_quantity.split('continue').pop());

    textforbutton = addtocart_text;
    
    if(inventory_management == null){
      _btnaddtocart.html(addtocart_text).removeClass('disable');
    }
    else{
      if(iq <= 0){
        _btnaddtocart.html(preorderhtml_text).removeClass('disable');
        textforbutton = preorderhtml_text;
      }
      else{
        _btnaddtocart.html(addtocart_text).removeClass('disable');
      }
    }
    
    _parent.find('.checkbox-group').length && _parent.find('.checkbox-group').removeClass('hidesoldout');
    _parent.find('.buyinoneclick').length && _parent.find('.buyinoneclick').removeClass('hidesoldout');
  }
  else {
    _btnaddtocart.html(unavailable_text).addClass('disable');
    
    _parent.find('.checkbox-group').length && _parent.find('.checkbox-group').addClass('hidesoldout');
    _parent.find('.buyinoneclick').length && _parent.find('.buyinoneclick').addClass('hidesoldout');
  }
}


/* cart api */
var addToCartHandler = {
  initItemAddToCartButton: function(){
    var _btns = $('.addtocart-item-js');
    $('body').on('click', '.addtocart-item-js', function(e){
      e.preventDefault();
      var variant_id = $(this).closest('form').find('input').val();
      Shopify.addItem(variant_id, 1);
    })
  },
  initFormAddToCartButton: function(variant_id, _parent, _swatch){
    var _btn = _parent.find('.addtocart-js');
    if(_btn.length == 0) return false;

    _btn.unbind().on('click', function(e){
      e.preventDefault();

      var form_id = _btn.closest("form").attr("id");
      Shopify.addItemFromForm(form_id)

      typeof quick_view_loader !== 'undefined' && quick_view_loader.wait(_btn);
    })
  },
  addItem: function(line_item) {
    relatedCartProducts.handle = line_item.handle;
    
    var _parent = $('header').find('.tt-cart');
    var _empty_cart = $('.tt-cart-empty');
    var _ul = _parent.find('.tt-cart-list');

    var price_str = getItemFormatedPrice(line_item.price);
    var _ = $('.item-html-js').children().clone();
    _.find('.tt-title').html(line_item.product_title);
    _.find('.tt-price').html(price_str);
    _.find('.qty').html(line_item.quantity);
    _.find('>a:first-child').attr('href', line_item.url);

    var _img = _.find('.tt-item-img').empty();
    $('<img src='+line_item.image+' alt="Cart Image">').appendTo(_img);
    
    var _details = _.find('.details');
    line_item.variant_title == null ? _details.parent().remove() : _details.html(line_item.variant_title.replace(/ \//g, ', '));

    var delete_btn = _.find('.header_delete_cartitem_js');
    var delete_url = String(delete_btn.attr('href')).replace('id=0', 'id='+line_item.id);
    delete_btn.attr('href', delete_url);
    
    _ul.find('[href="'+delete_url+'"]').length && _ul.find('[href="'+delete_url+'"]').closest('.tt-item').remove();
    $(_).prependTo(_ul);
    !_empty_cart.hasClass('hide') && _empty_cart.addClass('hide');
    
    var tt_cb = _parent.find('.tt-cart-box');
    tt_cb.hasClass('hide') && tt_cb.removeClass('hide');
    
    var _ul_children = _ul.children();
    _ul_children.length && _ul_children.hide();
    _ul_children.each(function(index){
      if(index >= 3) return false;
      $(this).show();
    });
    _ul_children.length > 3 && $('.header-cart-more-message-js').show();
  },
  updateGeneralInfo: function(cart){
    var price_str = getItemFormatedPrice(cart.total_price);
    var _parent = $('header').find('.tt-cart');
    _parent.find('.tt-badge-cart').text(cart.item_count);
    cart.item_count == 0 ? _parent.find('.tt-badge-cart').addClass('hide') : _parent.find('.tt-badge-cart').removeClass('hide');
    _parent.find('.tt-cart-total-price').empty().html(price_str);
  }
}

var addedModal = {
  $modal: $('#modalAddToCartProduct'),
  initSingleItem: function(line_item){
    relatedCartProducts.handle = line_item.handle;

    var price_str = getItemFormatedPrice(line_item.price*line_item.quantity);
    var _ = this.$modal;
    _.find('.tt-title-js').html(line_item.product_title);
    var _details = _.find('.description');
    
    var str = '';
    for(var i=0; i<3; i++){
      var opt = line_item.variant_options[i];
      if(opt != null) str += opt + ', ';
    }
	str = str.substring(0, str.length-2);
    
    line_item.variant_title == null ? _details.hide() : _details.show().html(str);
    _.find('.tt-qty span').first().empty().text(line_item.quantity);
    _.find('.total-product-js .tt-price').first().empty().html(price_str);

    var _img = _.find('.tt-img').empty();
    line_item.image !== null && $('<img src="'+line_item.image+'" alt="Added Product">').appendTo(_img);
  },
  initGeneralInfo: function(cart){
    var price_str = getItemFormatedPrice(cart.total_price);
    var _ = this.$modal;
    _.find('.modal-total-quantity').text(cart.item_count);
    _.find('.full-total-js').html(price_str);
  },
  showModal: function(){
    if(typeof modal_qv_open !== 'undefined') {
      if(modal_qv_open) return false;
    }

    var $this = this.$modal;
    
    $this.modal('show');
    
    var _ = this.$modal;
    _.find('.close-modal-added-js').click(function(e){
      e.preventDefault();
      $(this).unbind();
      $this.modal('hide');
    })

    $this.on('shown.bs.modal', function(){
      $(this).unbind('shown.bs.modal');
      relatedCartProducts.init();
    });
    $this.on('hidden.bs.modal', function(){
      $(this).unbind('hidden.bs.modal');
      relatedCartProducts.destroy();
    });
  }
}
var relatedCartProducts = {
  handle: false,
  init: function(){
    if(!$('.tt-modal-slider-js').length || !$('.tt-modal-slider').length || !related_collection_item) return false;
    
    $.ajax({
      type: "GET",
      url: '/collections/'+related_collection_item+'?view=ajax_related',
      success: function(data) {
        if(data == '') return false;
        $('.tt-modal-slider').removeClass('hide');
        $('.tt-modal-slider-js').append(data);
        $('.tt-modal-slider-js').find('.'+relatedCartProducts.handle).remove();
        relatedCartProducts.initSlider();
        data = null;
      },
      error: function(XMLHttpRequest, textStatus) {
      },
      dataType: "html"
    })
  },
  initSlider: function(){
    $('.tt-modal-slider-js').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  },
  destroy: function(){
    if(!$('.tt-modal-slider-js').length || !$('.tt-modal-slider').length || !related_collection_item) return false;
    $('.tt-modal-slider-js').slick('unslick').empty();
    $('.tt-modal-slider').addClass('hide');
    relatedCartProducts.handle = false;
    related_collection_item = false;
  }
}
var related_collection_item = false;
$('body').on('click', '.addtocart-item-js, .addtocart-js', function(e){
  var attr = $(this).attr('data-relatedcollection');
  if (typeof attr !== typeof undefined && attr !== false) {
    related_collection_item = attr;
  }
})

function getItemFormatedPrice(value){
  return Shopify.formatMoney(value, money_format);
}

/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
  addToCartHandler.addItem(line_item);
  addedModal.initSingleItem(line_item);
};

Shopify.onCartUpdate = function(cart) {
  addToCartHandler.updateGeneralInfo(cart);
  addedModal.initGeneralInfo(cart);
  addedModal.showModal();
  typeof quick_view_loader !== 'undefined' && quick_view_loader.added();
  $('body').trigger('refreshCurrency');
};
Shopify.onError = function(XMLHttpRequest, textStatus) {
  if(typeof modal_qv_open !== 'undefined') {
    if(modal_qv_open) {
      quick_view_loader.error();
      return false;
    }
  }

  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  $('#modalAddToCartError .error_message').text(str);
  $('#modalAddToCartError').modal("toggle");
}

var removeFromCartHandler = function(){
  $('body').on('click', '.header_delete_cartitem_js', function(e){
    e.preventDefault();
    $(this).closest('.tt-item').addClass('removeAfterCompleteAjax');
    var variant_id = getIdFromUrl($(this).attr("href"));
    Shopify.removeItem(variant_id, onCartUpdateCustom);
  });
}
function onCartUpdateCustom(cart){
  if(cart.item_count == 0){
    $('.tt-cart-empty').removeClass('hide');
    $('.tt-cart-box').addClass('hide');
  }
  
  _ul_children = $('header').find('.tt-cart').find('.tt-cart-list').children();
  
  _ul_children.each(function(index){
    if(index == 4) return false;
    $(this).show();
  });

  _ul_children.length <= 4 && $('.header-cart-more-message-js').hide();

  $('.removeAfterCompleteAjax').remove();
  addToCartHandler.updateGeneralInfo(cart);
  $('body').trigger('refreshCurrency');
}
function getIdFromUrl(url){
  url = url.match(/id=\d+/g);
  return url[0].match(/\d+/g);
}
addToCartHandler.initItemAddToCartButton();
removeFromCartHandler();